<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-col :xs="24" :sm="24" :lg="16">
      <el-button type="normal" @click.prevent="goBack" class="ml-20">
        <i class="el-icon-d-arrow-left"> 回我的簽核</i>
      </el-button>
    </el-col>
    <el-col :xs="24" :sm="24" :lg="8" class="text-right">
      <el-button v-if="alreadySigned === 'no'" type="primary" @click.prevent="handleSign" class="mr-20">簽核 <i
          class="el-icon-s-claim"></i></el-button>
      <el-tag v-if="alreadySigned === 'yes'" type="warning" class="mr-20">已簽核</el-tag>
    </el-col>


   

    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>日報資料</span>
            
          </div>
          <div>
            <el-form :model="basicForm"
                     ref="dataForm"
                     label-width="100px">

              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="填單人" prop="userObj.username" >
                    <el-input readonly v-model="basicForm.userObj.username"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題" prop="title">
                    <el-input readonly v-model="basicForm.title" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="報表日期" prop="startDate" >
                    <el-date-picker type="date" placeholder="選擇日期" readonly v-model="basicForm.startDate"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>        


              
            </el-form>

          </div>
        </el-card>
      </el-main>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>工作日報</span>
            <el-button v-if="basicForm.status === 'draft'" style="float: right; padding: 5px 12px" 　type="primary"
                       @click.prevent="handleAdd" class="mr-20">新增工作日報 <i class="el-icon-s-claim"></i></el-button>
          </div>
          <div>
            <el-table :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
              <el-table-column label="類型" prop="logType">
              </el-table-column>
              <el-table-column label="產品與數量">
                <template slot-scope="scope">
                  {{scope.row.product}} * {{scope.row.qty}}
                </template>
              </el-table-column>
              <el-table-column label="效果" prop="result">
              </el-table-column>
              <el-table-column label="進度" prop="progress">
              </el-table-column>

              <el-table-column label="附件" type="expand">
                <template slot-scope="scope">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <ol>
                      <li v-for="f in scope.row.fileListDisplay" :key="f.id">
                        ({{f.fileNote}})<a :href="displayAvatar(f.fileRepo.uuid)">{{f.fileRepo.name}}</a>
                      </li>
                    </ol>
                  </el-form>
                </template>
              </el-table-column>

              <el-table-column label="" width="200" v-if="basicForm.status !== 'draft'">

              </el-table-column>

              <el-table-column label="操作" width="200" v-if="basicForm.status === 'draft'">
                <template slot-scope="scope">
                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="handleDelete(scope.row.id)"
                  >
                    <el-button type="danger" slot="reference">刪除 <i class="el-icon-delete"></i></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>


            </el-table>


          </div>
        </el-card>
      </el-main>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="簽核資訊"
               :visible.sync="dialogFormVisible"
               :width="dw">

      <el-form :model="form" ref="signForm" label-width="100px" :rules="signFormRules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="簽核選擇" prop="signResult">
              <el-radio v-model="form.signResult" label="Y">同意</el-radio>
              <el-radio v-model="form.signResult" label="N">退回</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="備註" prop="notes">
              <el-input rows="5" type="textarea" v-model="form.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendSignoff('signForm')">確 定</el-button>
      </div>
    </el-dialog>

  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'

export default {
  name: "TodoDetailEmpMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let checkRadio = (rule, value, callback) => {
      console.log("checkRadio:", rule, value)
      if (value === '') {
        callback(new Error('請選擇同意或退回'))
      } else {
        callback()
      }
    }

    return {
      dw: '60%',
      alreadySigned: '',
      tableData: [],
      options: [],
      logTypeOptions: [{
        value: '補漆',
        label: '補漆'
      }, {
        value: '補缺',
        label: '補缺'
      }],
      basicForm: {
        id: '',
        title: '',
        startDate: '',
        endDate: '',
        status: '',
        userObj:{}
      },
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      btnCount: 0,
      form: {
        id: '',
        todoId: '',
        signResult: '',
        notes: '',
        relatedUser: '',
        flowStep:''
      },
      signFormRules: {
        signResult: [{required: true, validator: checkRadio, trigger: 'change'}],
        notes: [{required: true, validator: checkName, trigger: 'change'}]
      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo'])
  },
  methods: {
    goBack() {
      this.$router.push('/message/my-signoff')
    },
    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    save(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('valid:', valid)
        if (valid) {
            this.request.post("/todo/emp/history", this.form).then(res => {
              if (res.code === '200') {
                this.dialogFormVisible = false
                this.loadHistoryData()
                this.showResult('success', '新增成功')
              } else {
                this.showResult('error', res.message)
              }
            })
        }
      });

      
    },
    closeDialog() {
      this.$refs['dailyJobRuleForm'].resetFields()
      this.loadHistoryData()
    },

    formDefault() {
      this.request.get("/todo/" + this.form.todoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      // this.form.todoType = this.getTodoType()
    },

    loadHistoryData() {

      //先撈job
      this.request.get("/job/" + this.form.id).then(res => {
        if (res.code === '200') {
          this.form.todoId = res.data.todoId
          this.form.relatedUser = res.data.relatedUser
          this.form.flowStep = res.data.flowStep
          this.alreadySigned = res.data.alreadySigned
          
          this.formDefault()
          
          this.request.get("/todo/emp/history/" + this.form.todoId).then(res => {
            if (res.code === '200') {
              this.tableData = res.data
            } else {
              this.showResult('error', '工作紀錄撈取失敗')
            }
          })

        } else {
          this.showResult('error', '工作訪紀錄撈取失敗')
        }
      })
      
    },
    
    handleSign() {
      this.dialogFormVisible = true
      this.form.notes = ''
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 500; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%";
      }
    },
    handleDelete(id) {
      this.request.delete("/todo/emp/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    sendSignoff(formName) {
      this.$refs[formName].validate(async valid => {
        // console.log('this.form:', valid)
        if (valid) {
          this.request.post("/job", this.form).then(res => {
            if (res.code === '200') {
              this.showResult('success', '完成簽核')
              this.dialogFormVisible = false
              this.$router.push('/message/my-signoff')
            } else {
              this.showResult('error', '簽核結果儲存失敗')
            }
          })
        }
      })
    }
  },
  mounted() {

    this.form.id = this.$route.params.jobId

    this.loadHistoryData()

    

    window.onresize = () => {
      return (() => {
        this.setDialogWidth();
      })();
    };
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}


</style>
